import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService, AuthenticationService, ShipmentService } from '../../../services';

import {  COMMENT, PENDING_PRINTING } from '../../../../ngrx/status-types';
import {  SET_ORDER_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';

@Component({
  selector: 'pending-print-modal',
  templateUrl: 'pending-print-modal.component.html'
})
export class PendingPrintModal implements OnInit, OnDestroy {
  @ViewChild('textInput') textInput: ElementRef;
  @Input('order') order;
  @Input('shipment') shipment;
  comment      : string;
  userRole     : string;

  constructor(
    private authService      : AuthenticationService,
    private orderService     : OrderService,
    private shipmentService  : ShipmentService,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService
  ) {
  }
  ngAfterViewInit() {
    setTimeout(() => this.textInput.nativeElement.focus());
  }
  
  ngOnInit(): void {
    this.userRole                = this.authService.getUserRole();
  }

  ngOnDestroy(): void {
    this.modalService.getModalsCount();
    this.modalService.hide(1);
  }

  pendOrder(): void {
    if ((this.userRole === 'ADMIN' || this.userRole === 'CS' || this.userRole === 'SUPERVISOR') && this.comment) {
      this.modalService.getModalsCount();
      this.closeModal()

      this.store.dispatch({
        type   : SET_ORDER_DETAILS_VIEW,
        payload: { loading: true }
      });

      const history = {
        activity  : PENDING_PRINTING,
        note      : this.comment,
        user      : this.authService.getCurrentUser(),
        timestamp : (new Date).getTime().toString(),
        comment   : null,
      };

      if(this.shipment) {
        if(this.shipment.activity_history) { 
          this.shipment.activity_history.unshift(history);
        } else {
          this.shipment.activity_history = [history];
        }
        this.shipment.shipmentStatus = PENDING_PRINTING;
        this.shipmentService.updateShipment(this.shipment);
      }

      let updatedOrder = Object.assign({}, this.order);
      updatedOrder.previous_status = this.order.status;
      updatedOrder.status          = PENDING_PRINTING;
      updatedOrder.activity_history.unshift(history);

      this.orderService.updateOrder(updatedOrder);
      this.comment  = null;
    }
  }

  closeModal() {
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/pending-print-modal/pending-print-modal.component.ts